
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/[lang]/office-catering/vendors",
      function () {
        return require("private-next-pages/[domain]/[lang]/office-catering/vendors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/[lang]/office-catering/vendors"])
      });
    }
  